module.exports = __webpack_public_path__ + "static/media/1_en.0d3d8c39.png";